// src/pages/CaseHistoryPage/formApi.js
import api from '../../services/api';

export const getFormSchema = (version) => api.get('/case-history/form-schema', { params: version ? { version } : {} });
export const getSections = (caseId) => api.get(`/case-history/cases/${caseId}/sections`);
export const saveSection = (caseId, key, answers) =>
    api.put(`/case-history/cases/${caseId}/sections/${key}`, { answers });
export const setSectionNA = (caseId, key, reason) =>
    api.post(`/case-history/cases/${caseId}/sections/${key}/na`, { is_na: true, reason });
export const getCompletion = (caseId) => api.get(`/case-history/cases/${caseId}/completion`);
export const submitCase = (caseId) => api.post(`/case-history/cases/${caseId}/submit`);

/** Pick the right language(s) for a {hi, en} label. */
export function label(text, lang) {
    if (!text) return '';
    if (lang === 'hi') return text.hi || text.en || '';
    if (lang === 'en') return text.en || text.hi || '';
    return { hi: text.hi, en: text.en };   // 'both'
}
